import { reactSelectStylingConst, STYLES } from "../../../../constants";

const { blackColor, transparentColor } = reactSelectStylingConst;

// Changing default style of options in react select
export const customStyle = {
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? transparentColor : STYLES.AUTO,
    color: blackColor,
  }),
};
